import React from 'react';
import styled from 'styled-components';
import { BsFillGridFill, BsList } from "react-icons/bs";
import { useFilterContext } from '../context/filter_context';

const Sort = () => {
  const {filter_products,grid_view,setGridView,setListView,sorting}=useFilterContext();


return (
    <Wrapper className="sort-section">
      {/*first column */}
      <div className='sorting-list--grid'>
        <button className={grid_view ? 'active sort-btn':'sort-btn'} onClick={setGridView}>
        <BsFillGridFill className="icon" />
        </button>
        <button className={grid_view ? ' sort-btn':'active sort-btn'} onClick={setListView}>
        <BsList className="icon" />
        </button>
      </div>
 
       {/*second column */}
      <div className='product-data'>
        <p>{`${filter_products.length} Product Available`}</p>
      </div>

       {/*third column */}
      
      <div className='sort-selection'>
        <form>
          <label htmlFor='sort'></label>
          <select
            name="sort"
            id="sort"
            className='sort-selection--style'
            onChange={(e) => sorting(e.target.value)} 
          >
            <option value="#">--select--</option>
            <option value="lowest">Price (Lowest)</option>
            <option value="highest">Price (Highest)</option>
            <option value="a-z">Name (A-Z)</option>
            <option value="z-a">Name (Z-A)</option>
          </select>
        </form>
      </div>

    </Wrapper>
  )
}
const Wrapper = styled.section`
  display: flex;
  justify-content: space-between;
  padding : 2rem;

  .sorting-list--grid {
    display: flex;
    gap: 2rem;
    align-items: center;
             
  .sort-btn {
    display: flex;
    padding: 0.5rem 0.75rem;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: none;
    }
 
  .sort-btn:hover {
    background-color: ${({ theme }) => theme.colors.border};
    }

  .icon {
    font-size: 2rem;
    }
   
  .active {
    background-color: ${({ theme }) => theme.colors.black};
    color: #fff;
    }
  }    
  
  .product-data {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    }
  .product-data p {
    margin: 0; 
    flex-wrap: wrap;
    }

  .sort-selection {
    display: flex;
    align-items: center;
    justify-content: center;
  }

 .sort-selection form {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sort-selection--style {
    padding: 1.2rem 2.4rem;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.border};
    box-shadow: ${({ theme }) => theme.colors.shadowSupport};
   }
   
  .sort-selection--style option {
    padding: 0.5rem;
    cursor: pointer;
    }
    
  
  
  @media (max-width: ${({ theme }) => theme.media.mobile}){
  padding : 1rem;

  .sorting-list--grid {
    gap: 1rem;}
  
  .product-data {
    flex-wrap: wrap;  
    text-align: center;
    }

  .product-data p {
    margin: 0; 
    font-size: 1.5rem;
    }
.sort-selection--style {
    padding: 1rem 2rem;
    margin-right:1rem;
   }
       
}
    
`;

export default Sort
